// import { useEffect, useState } from "react";
// import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";

import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";

import AddOther from "./AddOther";

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 32,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    paddingBottom: 0,
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
}));

const Modal = ({ descData = "", isOpen = false, onClose, onSubmit }) => {
  // const [editTextDesc, setEditTextDesc] = useState("");

  // useEffect(() => {
  //   if (isOpen) {
  //     setEditTextDesc(descData);
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isOpen]);

  // const getDescText = async () => {
  //   let text = ""
  //   suggestDescList
  //     .filter((item) => item.isSelect === true)
  //     // eslint-disable-next-line array-callback-return
  //     .map((selected, i) => {
  //       if (text === "")
  //         text = `${selected?.description_text}`
  //       else
  //         text = `${text}\n${selected?.description_text}`
  //     });

  //   await onSubmit(text);
  // };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 740,
          },
        },
      }}
    >
      <DialogTitle sx={{ p: 3, textAlign: "center" }}>
        เพิ่มสินค้าใหม่นอกเว็บไซต์
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            borderRadius: "50%",
            border: "1px solid var(--lightgrey-color)",
            position: "absolute",
            right: 16,
            top: 16,
            color: "var(--primary-color)",
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          px: 3,
          width: "100%",
          "& .MuiBox-root": {
            maxWidth: "530px",
            mx: "auto",
          },
        }}
      >
        <AddOther onSubmit={onSubmit} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
